import { useMeasurementSystem } from "../../hooks/useMeasurementSystem";
import { Toggle } from "./Toggle";

const MEASUREMENT_OPTIONS = [
  { value: "imperial", label: "imperial" },
  { value: "metric", label: "metric" },
];

export function MeasurementToggle({ onChange }) {
  const { measurementSystem, setMeasurementSystem } = useMeasurementSystem();

  const handleChange = (newValue) => {
    setMeasurementSystem(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  return (
    <Toggle
      options={MEASUREMENT_OPTIONS}
      value={measurementSystem}
      onChange={handleChange}
    />
  );
}
